<template>
  <div class="card no-body">
    <div class="card-header d-flex">
        <h5 class="h3 mb-0">Recent Jobs</h5>
        <b-button @click="goTo" size="sm" v-b-popover.hover.left="'Go to Job Search Page'" variant="outline-primary" class="ml-auto">View All</b-button>
    </div>

    <div v-if="session.loadedFirstPage">
        <div v-if="session.jobList.length > 0">
            <b-list-group flush class="job-list-group">
              <b-list-group-item v-for="job in session.jobList" :key="job.jobId" class="mx-0 p-0 py-1">
                <job-horizontal-card :job="job"></job-horizontal-card>
              </b-list-group-item>
            </b-list-group>
        </div>
        <div v-else class="text-center p-3">
            <div> No jobs in this project yet. </div>
        </div>
    </div>
    <div v-else class="text-center p-3">
      <b-spinner size="sm"></b-spinner>
    </div>
    <div class="card-footer">
      <b-form-invalid-feedback :state="!session.errorMessage" class="text-center">
          {{session.errorMessage}}
      </b-form-invalid-feedback>
    </div>
  </div>
</template>

<script>

import JobHorizontalCard from '#/ui/Components/JobHorizontalCard.vue';
import { JobListSession } from '#/services/jobs';

export default {
  components: {
    JobHorizontalCard,
  },
  data() {
    const accountId = this.$store.getters.activeAccountId;
    const projectId = this.$store.getters.activeProjectId;
    return {
      session: new JobListSession(accountId, projectId),
    };
  },
  created() {
    return this.loadPage();
  },
  methods: {
    async loadPage() {
      return this.session.loadPage();
    },
    jobThumb(item) {
      if (!item.keyEntityWasExpanded || !item.expandedKeyEntity || item.expandedKeyEntity.expandedThumbnailsList.length < 1) {
        console.log('no thumb for job', item.jobId);
        return 'null';
      }
      const [thumb] = item.expandedKeyEntity.expandedThumbnailsList;
      return thumb.signedUrl;
    },
    goTo() {
      const path = '/jobs';
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
</style>
